import { useApiClient } from '@/composables/useApiClient'

const KEY_SEARCH_HISTORY = 'searchHistory'

export const state = () => ({
  selectedRegion: null,
  selectedCategoryId: null,
  searchKeyword: '',
  searchKeywordsOfRegion: [],
  searchKeywordsOfCategory: [],
  searchKeywordsOfHistory: [],
})

export const getters = {
  selectedRegion: state => state.selectedRegion,
  selectedCategoryId: state => state.selectedCategoryId,
  searchKeyword: state => state.searchKeyword,
  searchKeywordsOfRegion: state => state.searchKeywordsOfRegion,
  searchKeywordsOfCategory: state => state.searchKeywordsOfCategory,
  searchKeywordsOfHistory: state => state.searchKeywordsOfHistory,
}

export const actions = {
  setSelectedRegion({ commit }, region) {
    commit('SET_SELECTED_REGION', region)
  },
  setSelectedCategoryId({ commit }, categoryId) {
    commit('SET_SELECTED_CATEGORY', categoryId)
  },
  setSearchKeyword({ commit }, keyword) {
    commit('SET_SEARCH_KEYWORD', keyword || '')
  },
  getSearchKeywords({ commit }, { regionID, categoryID, limit }) {
    const params = { region_id: regionID, category_id: categoryID, limit: limit }
    return useApiClient().$get('/search/keywords', { params: params })
  },
  fetchSearchKeywordsOfRegion({ dispatch, commit }, { regionID }) {
    dispatch('getSearchKeywords', { regionID: regionID, limit: 15 })
      .then(res => {
        if (res.code === 0) {
          commit('SET_SEARCH_KEYWORDS_OF_REGION', res.data)
        }
      })
      .catch(err => {
        console.error('fetchSearchKeywordsOfRegion: error', err)
        return err
      })
  },
  fetchSearchKeywordsOfCategory({ dispatch, commit }, { regionID, categoryID }) {
    dispatch('getSearchKeywords', { regionID, categoryID, limit: 8 })
      .then(res => {
        if (res.code === 0) {
          commit('SET_SEARCH_KEYWORDS_OF_CATEGORY', res.data)
        }
      })
      .catch(err => {
        console.error('fetchSearchKeywordsOfCategory: error', err)
        return err
      })
  },
  initHistorySearchKeyword({ commit }) {
    const historyArr = JSON.parse(localStorage.getItem(KEY_SEARCH_HISTORY))
    commit('SET_SEARCH_KEYWORDS_OF_HISTORY', historyArr)
  },
  saveHistorySearchKeyword({ commit, state }, keyword) {
    const historyArr = [...state.searchKeywordsOfHistory]
    if (historyArr.includes(keyword)) {
      const wordIdx = historyArr.indexOf(keyword)
      historyArr.splice(wordIdx, 1)
    }

    historyArr.unshift(keyword)

    if (historyArr.length > 10) {
      historyArr.pop()
    }

    commit('SET_SEARCH_KEYWORDS_OF_HISTORY', historyArr)
    localStorage.setItem(KEY_SEARCH_HISTORY, JSON.stringify(historyArr))
  },
  removeHistorySearchKeyword({ commit }) {
    commit('SET_SEARCH_KEYWORDS_OF_HISTORY', [])
    localStorage.removeItem(KEY_SEARCH_HISTORY)
  },
}

export const mutations = {
  SET_SELECTED_REGION(state, region) {
    state.selectedRegion = region
  },
  SET_SELECTED_CATEGORY(state, categoryId) {
    state.selectedCategoryId = categoryId
  },
  SET_SEARCH_KEYWORD(state, keyword) {
    state.searchKeyword = keyword
  },
  SET_SEARCH_KEYWORDS_OF_REGION(state, keywords) {
    state.searchKeywordsOfRegion = keywords || []
  },
  SET_SEARCH_KEYWORDS_OF_CATEGORY(state, keywords) {
    state.searchKeywordsOfCategory = keywords || []
  },
  SET_SEARCH_KEYWORDS_OF_HISTORY(state, keywords) {
    state.searchKeywordsOfHistory = keywords || []
  },
}
